<template>
  <el-menu default-active="2">
    <el-menu-item
      :class="
        routerActiveClass([
          'admin_releases',
          'admin_releases_draft',
          'admin_release_edit'
        ])
      "
      @click="$router.push({ name: 'admin_releases' })"
      >版本发布管理</el-menu-item
    >
    <el-menu-item
      :class="
        routerActiveClass([
          'admin_repos',
          'admin_repos_draft',
          'admin_repo_edit'
        ])
      "
      @click="$router.push({ name: 'admin_repos' })"
      >资料管理</el-menu-item
    >
    <el-menu-item
      :class="routerActiveClass(['admin_nodes'])"
      @click="$router.push({ name: 'admin_nodes' })"
      >节点管理</el-menu-item
    >
    <el-menu-item
      :class="routerActiveClass(['admin_users'])"
      @click="$router.push({ name: 'admin_users' })"
      >用户管理</el-menu-item
    >
  </el-menu>
</template>

<script>
export default {
  name: "Sidebar",
  methods: {
    routerActiveClass(names = []) {
      for (let name of names) {
        if (this.$route.name === name) {
          return "active";
        }
      }
      return "";
    }
  }
};
</script>

<style scoped lang="scss">
.el-menu {
  border-right: none;
}
@mixin active-style {
  background-color: #a8b6ca;
  color: white;
}
.active {
  @include active-style;
  &:hover {
    @include active-style;
  }
  &:focus {
    @include active-style;
  }
}
li {
  font-size: 1.1rem;
}
</style>
